import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  gameImage: {
    height: 160,
    width: 120,
    borderRadius: 20,
  },
}));
